import { Body } from 'components/Typography';
import styled from 'styled-components';
import { Field, Form as FormikForm } from 'formik';
import { Box as DefaultBox } from '@material-ui/core';

/* eslint-disable import/prefer-default-export */
// TODO: TFR-44 move to container group or do not export
export const Container = styled.div`
  background: ${({ theme }) => theme.colors.white};
  box-shadow:
    0rem 0.5rem 1rem rgba(35, 35, 35, 0.02),
    0rem 0.5rem 2rem rgba(35, 35, 35, 0.02);
  border-radius: 1.5rem;
  padding: 1.5rem;
`;

export const RowContainer = styled.div`
  @media (max-width: 768px) {
    flex-direction: column;
    margin-left: 1rem;
    margin-right: 1rem;
  }
  @media (min-width: 768px) {
    flex-direction: row;
    margin-left: 2rem;
    margin-right: 2rem;
    margin-top: 1.5rem;
  }
  background: ${({ theme }) => theme.colors.white};
  display: flex;
`;
// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const Form = styled(FormikForm)`
  padding-bottom: 10rem;
`;

export const StyledField = styled(Field)``;

export const Box = styled(DefaultBox)`
  @media (max-width: 768px) {
    width: 100%;
    margin-top: 1.5rem;
  }
  @media (min-width: 768px) {
    width: 49%;
  }
  margin-right: 1.5rem;
`;

export const FieldDescription = styled(Body)`
  @media (max-width: 768px) {
    margin-top: 0;
  }
  @media (min-width: 768px) {
    margin-top: 0.5rem;
  }
  color: ${({ theme }) => theme.colors.gray5};
  margin-top: 0.5rem;
  margin-bottom: 1rem;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
`;
